import { defineMessages } from 'react-intl';

export default defineMessages({
  pleaseSelect: {
    id: 'AppointmentsProject.pleaseSelect',
    defaultMessage: 'Please select a time slot:',
  },
});
